import OrganisationsDataGrid from '../components/dataGrids/organisationsDataGrid';
import OrganisationsOverviewActionBar from '../components/organisationsOverviewActionBar';

const OrganisationsOverviewContainer = () => {
	return (
		<>
			<OrganisationsDataGrid />
			<OrganisationsOverviewActionBar />
		</>
	);
};

export default OrganisationsOverviewContainer;
